// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getAuth,
  GoogleAuthProvider,
  FacebookAuthProvider,
  TwitterAuthProvider,
  setPersistence,
  browserLocalPersistence,
  signInWithRedirect,
  getRedirectResult,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBU-QmKwOpnXCJa0oE9fZwPI-keJBdpzu4",
  authDomain: "digital-album-2cec3.firebaseapp.com",
  projectId: "digital-album-2cec3",
  storageBucket: "digital-album-2cec3.appspot.com",
  messagingSenderId: "11407872834",
  appId: "1:11407872834:web:756adbbba656871c262edb",
  measurementId: "G-8M6MXL0MY0",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const db = getFirestore(app);
auth.useDeviceLanguage();
const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account",
});

const facebookProvider = new FacebookAuthProvider();
facebookProvider.setCustomParameters({});

const twitterProvider = new TwitterAuthProvider();

export const signInWithGoogle = () => {
  signInWithRedirect(auth, googleProvider).then((result) => {
    return result;
  });
};

export const signInWithFacebook = () => {
  signInWithRedirect(auth, facebookProvider).then((result) => {
    return result;
  });
};

export const signInWithTwitter = () => {
  signInWithRedirect(auth, twitterProvider).then((result) => {
    return result;
  });
};

setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // Existing and future Auth states are now persisted in the current
    // session only. Closing the window would clear any existing state even
    // if a user forgets to sign out.
    // ...
    // New sign-in will be persisted with session persistence.
    return signInWithGoogle;
  })
  .catch((error) => {
    // Handle Errors here.
    // const errorCode = error.code;
    // const errorMessage = error.message;
  });
